export const getTitleFromPaths  = (path:any) => {
console.log(path);

switch (path) {
    case "/":
        return "Home"
   
   
}
}